import { Link } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { CheckCircle2, ListChecks, Sparkles } from "lucide-react";
import { useTodaysChecklist } from "@/lib/tasks";

export default function ChecklistBanner() {
  const { total, done, loading } = useTodaysChecklist();

  if (loading) return null;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  const allDone = total > 0 && done === total;

  return (
    <Link
      to="/checklist"
      data-testid="checklist-banner"
      className="block rounded-2xl border-2 border-border hover:border-primary/50 bg-card p-5 sm:p-6 shadow-sm transition-all hover:-translate-y-[1px]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 100% 0%, hsl(var(--primary) / 0.08), transparent 45%)",
      }}
    >
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <div
            className={`size-10 rounded-xl flex items-center justify-center ${
              allDone ? "bg-primary text-primary-foreground" : "bg-primary/15 text-primary"
            }`}
          >
            {allDone ? (
              <CheckCircle2 strokeWidth={2} className="size-5" />
            ) : (
              <ListChecks strokeWidth={1.5} className="size-5" />
            )}
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
              Today's checklist
            </div>
            <h3
              className="font-display text-xl sm:text-2xl font-extrabold tracking-tight"
              data-testid="checklist-banner-headline"
            >
              {total === 0
                ? "No tasks yet — set today's to-dos"
                : allDone
                ? "All checked off. Beautiful work."
                : `${total - done} task${total - done === 1 ? "" : "s"} left to finish today`}
            </h3>
          </div>
        </div>
        {total > 0 && (
          <div className="flex items-center gap-2">
            <Sparkles strokeWidth={1.5} className="size-4 text-primary" />
            <span className="font-display font-extrabold text-2xl">
              {done}/{total}
            </span>
          </div>
        )}
      </div>
      {total > 0 && (
        <Progress value={pct} className="h-2 mt-4" data-testid="checklist-banner-progress" />
      )}
    </Link>
  );
}
